import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber, formatPercent } from "@/lib/format";
import type { CompositeFunnel as CFData } from "@/api/admin/economics";

const cardStyle: CSSProperties = {
  background: "var(--d-ink-2)",
  border: "1px solid var(--d-line)",
  borderRadius: 22,
  padding: 16,
  display: "flex",
  flexDirection: "column",
  gap: 10,
};

const titleStyle: CSSProperties = {
  fontFamily: "var(--font-display)",
  fontSize: 16,
  color: "var(--d-fg)",
  marginBottom: 6,
};

const rowStyle: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
};

const labelStyle: CSSProperties = {
  fontFamily: "var(--font-body)",
  fontSize: 12,
  color: "var(--d-fg-muted)",
};

const numStyle: CSSProperties = {
  fontFamily: "var(--font-mono)",
  fontSize: 16,
  fontVariantNumeric: "tabular-nums",
  color: "var(--d-fg)",
};

export function CompositeFunnel({ data, locale }: { data: CFData; locale: string }): JSX.Element {
  const { t } = useTranslation("admin");
  return (
    <div style={cardStyle}>
      <div style={titleStyle}>{t("economics.composite.title")}</div>
      <div style={rowStyle}>
        <span style={labelStyle}>{t("economics.composite.purchases")}</span>
        <span style={numStyle}>{formatNumber(data.composite_purchases, locale)}</span>
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>{t("economics.composite.opened")}</span>
        <span style={numStyle}>{formatNumber(data.composite_opened, locale)}</span>
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>{t("economics.composite.rate")}</span>
        <span style={{ ...numStyle, color: "var(--d-gold)" }}>
          {formatPercent(data.composite_open_rate * 100, locale, 1)}
        </span>
      </div>
    </div>
  );
}
